import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { TerminalDataModel } from '@nutricontrol/app360-shared';
import { ReportsService } from '../../reports.service';
import { ReportsWaterSourceModel } from '../../reports-irrigation.costs';
import { TranslationsLibService } from '@nutricontrol/app360-shared';
import Swal from 'sweetalert2';
import { IonModal } from '@ionic/angular';

@Component({
  selector: 'app-water-sources-table',
  templateUrl: './water-sources-table.component.html',
  styleUrls: ['./water-sources-table.component.scss'],
})
export class WaterSourcesTableComponent implements OnInit {
  @Input() terminal: TerminalDataModel;
  @ViewChild(IonModal) modal: IonModal;
  waterSources: ReportsWaterSourceModel[] = [];
  selectedWaterSource: ReportsWaterSourceModel | null = null;

  constructor(
    public translationLib: TranslationsLibService,
    private reportsService: ReportsService
  ) {}

  ngOnInit(): void {
    this.loadWaterSources();
  }

  loadWaterSources() {
    if (!this.terminal) {
      return;
    }
    this.reportsService.getWaterSources(this.terminal.vid).subscribe({
      next: (sources) => (this.waterSources = sources),
      error: (error) => console.error(error),
    });
  }

  openForm(source: ReportsWaterSourceModel | null) {
    this.selectedWaterSource = source;
    this.modal.present().then();
  }

  onEdit(source: ReportsWaterSourceModel) {
    this.openForm(source);
  }

  onWillDismiss(event: any) {
    if (event.detail.data === 'submitted') {
      this.loadWaterSources();
    }
    this.selectedWaterSource = null;
  }

  onFormSubmitted() {
    this.modal.dismiss('submitted').then();
  }

  onDelete(source: ReportsWaterSourceModel) {
    Swal.fire({
      title: this.translationLib.get('auth_confirm'),
      text: this.translationLib.get(
        'reports_sure_delete_water_source'
      ),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#224261',
      cancelButtonColor: '#d33',
      confirmButtonText: this.translationLib.get('delete'),
      cancelButtonText: this.translationLib.get('cancel'),
    }).then((result) => {
      if (result.isConfirmed) {
        this.reportsService.deleteWaterSource(source.vid).subscribe({
          next: () => {
            this.loadWaterSources();
            Swal.fire({
              title: this.translationLib.get('reports_delete'),
              text: this.translationLib.get(
                'reports_deleted_water_source'
              ),
              icon: 'success',
              confirmButtonColor: '#224261',
            }).then();
          },
          error: (error) => {
            console.error('reports_water_source_deleted_table', error);
          },
        });
      }
    });
  }
}
